module.exports = __webpack_public_path__ + "static/media/invitatie-personala-icon.221fa505.svg";